<template lang="pug">
.event-charge
  .purchase
    .info-tips
      .tips {{ userinfoRoleId === 3 ? "当前为试用版，每天查看5个事件" : "当前为个人专业版，每天查看10个事件" }}，升级
        span 企业专业版
        |
        | 查看更多事件
      .contactBar
        button(type="button")
          router-link(:to="{ name: 'MyVip' }") 联系客服购买
        <!--div.wechat(@click.prevent="toggleWechat")-->
        <!--  img(src="../assets/wechat1.png" width=20 height=20)-->
        <!--  transition(name="move")-->
        <!--    div.qrcode(v-if="showQrcode")-->
        <!--      img(src="../assets/qrcode.png")-->
        <!--div.qq(@click.prevent="toggleQQ")-->
        <!--  img(src="../assets/qq.png" width=20 height=20)-->
        <!--  transition(name="come")-->
        <!--    div.qq-number(v-if="showQQ") 2849888083-->
        <!--div.tel(@click.prevent="toggleTel")-->
        <!--  img(src="../assets/telephone.png" width=20 height=20)-->
        <!--  transition(name="come")-->
        <!--    div.tel-number(v-if="showTel") 400-811-3709-->
</template>
<script>
export default {
  name: 'EventCharge',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.from = from
    })
  },
  computed: {
    userinfoRoleId () {
      return this.$store.getters.levelId
    }
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  mounted () {
    if (this.event.hasRule) {
      this.$router.replace({
        name: 'EventGeneral',
        params: {
          id: this.$route.params.id
        }
      })
    }
  },
  watch: {
    event: {
      deep: true,
      handler () {
        if (this.event.hasRule) {
          this.$router.replace({
            name: 'EventGeneral',
            params: {
              id: this.$route.params.id
            }
          })
        }
      }
    }
  },
  data () {
    return {
      showMakeDecision: false,
      from: {},
      showQrcode: false,
      showQQ: false,
      showTel: false
    }
  },
  methods: {
    subscribe () {
      this.showMakeDecision = true
    },
    cancle () {
      this.showMakeDecision = false
    },
    toggleWechat () {
      this.showQrcode = !this.showQrcode
    },
    toggleTel () {
      this.showTel = !this.showTel
    },
    toggleQQ () {
      this.showQQ = !this.showQQ
    }
  },
  destroyed () {
    this.showMakeDecision = false
  },
  deactivated () {
    this.showMakeDecision = false
  }
}
</script>

<style lang="scss" scoped>
.event-charge {
  height: 100%;
  background-color: #fff;
  border-radius: 4px;
}

.info-tips {
  padding: 300px 0;
}

.tips {
  font-size: 16px;
  color: #666;
  text-align: center;

  span {
    color: #f87653;
  }
}

.buy {
  text-align: center;
  margin-top: 60px;
}

.buy button {
  width: 139px;
  height: 42px;
  background-color: rgba(69, 140, 200, 0.1);
  border: solid 1px #458cc8;
  font-size: 18px;
  color: #458cc8;
}

.subscribe {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 472px;
  height: 247px;
  margin-left: -236px;
  margin-top: -128px;
  background-color: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.6);
  border: solid 1px #c0c0c0;
  padding: 70px 0 30px 0;
  text-align: center;
}

.decision button {
  width: 97px;
  height: 30px;
  background-color: rgba(69, 140, 200, 0.1);
  border: solid 1px #458cc8;
  margin: 0 37.5px;
  color: #458cc8;

  &:hover {
    background: #458cc8;
    color: #fff;
  }
}

.text,
.decision {
  text-align: center;
}

.text {
  font-size: 18px;
  color: #737373;
  margin-bottom: 90px;

  span {
    color: #458cc8;
  }
}

.contactBar {
  margin-top: 30px;
  display: flex;
  justify-content: center;

  button {
    width: 140px;
    height: 44px;
    background-color: #3989cb;
    border-radius: 22px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      color: #fff;
    }
  }

  .wechat {
    margin: 0 20px;
    cursor: pointer;
    position: relative;
  }

  .qq {
    margin: 0 20px;
    cursor: pointer;
    position: relative;
  }

  .tel {
    margin: 0 20px;
    cursor: pointer;
    position: relative;
  }
}

.qrcode {
  position: absolute;
  left: -325px;
  top: 20px;
}

.qq-number {
  position: absolute;
  left: 0;
  top: 30px;
  text-align: center;
  line-height: 30px;
  height: 30px;
  width: 100px;
  color: #fff;
  background: #000;
  overflow: hidden;
  white-space: nowrap;
}

.tel-number {
  position: absolute;
  left: 30px;
  top: -5px;
  text-align: center;
  line-height: 30px;
  height: 30px;
  width: 100px;
  color: #fff;
  background: #000;
  overflow: hidden;
  white-space: nowrap;
}

.wechat {
  background-position: 5px 6px;
}

.qq {
  background-position: -37px 6px;
}

.tel {
  background-position: -167px 6px;
}

.move-enter-active,
.move-leave-active {
  transition: transform 0.5s;
  transform: scale(1);
  transform-origin: right top;
}

.move-enter,
.move-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  transform-origin: right top;
  transform: scale(0);
}

.come-enter-active,
.come-leave-active {
  transition: all 0.5s;
  transform: translate(0, 0);
  opacity: 1;
}

.come-enter,
.come-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  transform: translate(100%, 0);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventCharge/EventCharge.vue